'use strict';

module.exports = require('./es6/crc24').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc24.js
// module id = 644
// module chunks = 0